/* eslint-disable @typescript-eslint/ban-ts-comment*/
/* eslint-disable prefer-const*/
/* eslint-disable @typescript-eslint/restrict-plus-operands*/
import React, { FC, useState } from "react";
import MiniCallControl from "./Components/call-control/mini-callcontrol"
import CallControl from "./Components/call-control"

export const SettingsContext = React.createContext<any>(null);
export const MediaSettingsContext = React.createContext<any>(null);
interface IProps {
    meetingStatus: string;
    customerName: string;
    setMeetingStatus(status: string): void;
    mediaUrl: string;
}
const VoiceElements: FC<IProps> = ({ meetingStatus, setMeetingStatus, mediaUrl }) => {

    const [streamName, setStreamName] = useState("")

    const includeString = (meetStatus: string, arr: string[]) => {
        let result = false
        arr.forEach((val) => {
            if (meetStatus.includes(val)) {
                result = true
            }
        })
        return result
    }

    const _handleChangeRoomStatus = (status: string, arrStatus: string[]) => {
        if (includeString(meetingStatus, arrStatus))
            setMeetingStatus(status)
        else {
            setMeetingStatus(status)
        }
    }
    let incomingcallcontrol = (<></>)
    if (meetingStatus !== undefined) {
        if (includeString(meetingStatus, ["waiting", "missing"]))
            incomingcallcontrol = (<MiniCallControl
                mediaServerUrl={mediaUrl}
                meetingStatus={meetingStatus}
                streamName={streamName}
                handleStreamName={(name) => setStreamName(name)}
                handleChangeRoomStatus={(status) => {
                    _handleChangeRoomStatus(status, ["waiting", "meeting", "missing"])
                }
                }
            />);
        else if (meetingStatus.includes("meeting"))
            incomingcallcontrol = (<CallControl
                mediaServerUrl={mediaUrl}
                handleChangeRoomStatus={(status) => {
                    _handleChangeRoomStatus(status, ["waiting", "meeting"])
                }
                }></CallControl>);
    }

    return (
        incomingcallcontrol
    )
}
export default VoiceElements